export default __webpack_public_path__ + "static/media/default-medication.d7fbf409.png";